import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import { Drawer, Descriptions, Divider, Tag, Alert } from 'antd'
import { checkPermission } from '@/utils/permission';
import ReactHtmlParser from 'react-html-parser';
import { isValidDate, renderTelesaleDeadline, renderTelesaleFollowStatusTag, renderTelesaleTime, repeatPhoneNumber } from '@/utils/helpers';
import { isMobile } from 'react-device-detect';
import HandlePhoneNumber from '@/components/HandlePhoneNumber';

class TelesaleFollowUpDetail extends Component {

    handleCancel() {
        this.props.onCancel();
    }


    render() {

        var { visible, currentItem } = this.props;

        return (
            <>
                <Drawer
                    visible={visible}
                    title="Chi tiết telesale"
                    onClose={this.handleCancel.bind(this)}
                    maskClosable={false}
                    width={isMobile ? '100%' : '60%'}
                >
                    {currentItem && (
                        <>
                            {/* ================= A. THÔNG TIN KHÁCH HÀNG ================= */}
                            <Divider orientation="left" orientationMargin={0}>Thông tin khách hàng</Divider>
                            <Descriptions size="small" column={2} bordered>
                                <Descriptions.Item label="Khách hàng">
                                    {currentItem.customer?.full_name}
                                </Descriptions.Item>
                                <Descriptions.Item label="Mã khách hàng">
                                    <Tag color="blue">{currentItem.customer?.code}</Tag>
                                </Descriptions.Item>

                                <Descriptions.Item label="Số điện thoại">
                                    <HandlePhoneNumber
                                        permission={checkPermission('customer', 'phonenumber')}
                                        inputPinCode={checkPermission('customer', 'input_pin_code')}
                                        customer_id={currentItem.customer_id}
                                        hiddenPhoneNumber={repeatPhoneNumber(currentItem.customer?.phone)}
                                        fullPhoneNumber={currentItem.customer?.phone}
                                    />
                                </Descriptions.Item>

                                <Descriptions.Item label="Trạng thái khách hàng">
                                    <Tag color={currentItem.customer?.customer_status?.text_color}>
                                        {currentItem.customer?.customer_status?.name}
                                    </Tag>
                                </Descriptions.Item>

                                <Descriptions.Item label="Nguồn khách hàng">
                                    {currentItem.customer?.customer_source?.name}
                                </Descriptions.Item>

                                <Descriptions.Item label="Cơ sở">
                                    {currentItem.customer?.branche?.name}
                                </Descriptions.Item>
                            </Descriptions>

                            {currentItem.customer?.note && (
                                <Alert
                                    message="Ghi chú khách hàng"
                                    description={ReactHtmlParser(currentItem.customer.note)}
                                    type="info"
                                    className='fix-alert-element mt-2'
                                />
                            )}

                            {/* ================= B. THÔNG TIN TELESALE ================= */}
                            <Divider orientation="left" orientationMargin="0">Thông tin telesale</Divider>
                            <Descriptions size="small" column={2} bordered>
                                <Descriptions.Item label="Hình thức telesale">
                                    {currentItem.mode === 'assigned'
                                        ? <Tag color="blue">Được phân công</Tag>
                                        : <Tag>Chủ động</Tag>}
                                </Descriptions.Item>

                                <Descriptions.Item label="Deadline">
                                    {renderTelesaleDeadline(currentItem.deadline, currentItem.status, 'detail')}
                                </Descriptions.Item>

                                <Descriptions.Item label="Trạng thái">
                                    {currentItem.status === 1
                                        ? <Tag color="green">Đã trả kết quả</Tag>
                                        : <Tag color="orange">Chưa trả kết quả</Tag>}
                                </Descriptions.Item>

                                <Descriptions.Item label="Trạng thái follow">
                                    {renderTelesaleFollowStatusTag(currentItem.follow_status)}
                                </Descriptions.Item>

                                <Descriptions.Item label="Thời điểm telesale">
                                    {renderTelesaleTime(
                                        currentItem.deadline,
                                        currentItem.handled_at,
                                        'detail'
                                    )}
                                </Descriptions.Item>

                                <Descriptions.Item label="Dịch vụ quan tâm">
                                    {currentItem.service?.name || '--'}
                                </Descriptions.Item>

                                <Descriptions.Item label="Nhân viên tiếp nhận">
                                    {currentItem.accepted_by
                                        ? `${currentItem.accepted_by.user_role?.name} - ${currentItem.accepted_by.full_name}`
                                        : <Tag>Chưa tiếp nhận</Tag>}
                                </Descriptions.Item>

                                <Descriptions.Item label="Thời điểm tiếp nhận">
                                    {currentItem.accepted_at
                                        ? isValidDate(currentItem.accepted_at, true)
                                        : '--'}
                                </Descriptions.Item>

                                <Descriptions.Item label="Nhân viên được phân công" span={2}>
                                    {currentItem.staff?.map(st => (
                                        <Tag key={st.staff_id}>
                                            {st.user?.user_role?.name} - {st.user?.full_name}
                                        </Tag>
                                    ))}
                                </Descriptions.Item>
                            </Descriptions>

                            {/* ================= C. KẾT QUẢ TƯ VẤN ================= */}
                            <Divider orientation="left" orientationMargin="0">Kết quả tư vấn</Divider>
                            <Alert
                                message="Nội dung telesale"
                                description={
                                    currentItem.result_content
                                        ? ReactHtmlParser(currentItem.result_content)
                                        : <i>Chưa có kết quả</i>
                                }
                                type="info"
                                className='fix-alert-element'
                            />

                            {/* ================= D. THÔNG TIN HỆ THỐNG ================= */}
                            <Divider orientation="left" orientationMargin="0">Thông tin hệ thống</Divider>
                            <Descriptions size="small" column={2} bordered>
                                <Descriptions.Item label="Ngày tạo">
                                    {isValidDate(currentItem.created_at, true)}
                                </Descriptions.Item>

                                <Descriptions.Item label="Người tạo">
                                    {currentItem.created_user?.user_role?.name} - {currentItem.created_user?.full_name}
                                </Descriptions.Item>

                                <Descriptions.Item label="Cập nhật lần cuối">
                                    {isValidDate(currentItem.updated_at, true)}
                                </Descriptions.Item>

                                <Descriptions.Item label="Người cập nhật">
                                    {currentItem.handled_by?.user_role?.name} - {currentItem.handled_by?.full_name}
                                </Descriptions.Item>
                            </Descriptions>
                        </>
                    )}
                </Drawer>

            </>
        )
    }
}
function mapStateToProps(state) {
    return {
        authUser: state.auth.authUser
    }
}

function mapDispatchToProps(dispatch) {
    return {

    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Form.create({ name: 'TelesaleFollowUpDetail' })(TelesaleFollowUpDetail));
